<template>
  <div class="input">
    <div class="input-label">URL</div>
    <div class="input-group">
      <input type="text" class="input-text" v-model="url">
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    url: {
      get: function () {
        return this.$store.state.tourism.url
      },
      set: function (value) {
        this.$store.commit(
          'tourism/setUrl',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
